module.exports = __webpack_public_path__ + "img/icon_1.31c4fede.svg";